import { render, staticRenderFns } from "./RegistroEstudiante.vue?vue&type=template&id=53ac597a&scoped=true"
import script from "./RegistroEstudiante.vue?vue&type=script&lang=js"
export * from "./RegistroEstudiante.vue?vue&type=script&lang=js"
import style0 from "./RegistroEstudiante.vue?vue&type=style&index=0&id=53ac597a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ac597a",
  null
  
)

export default component.exports